// extracted by mini-css-extract-plugin
export default {"dialog-warning":"aUjHITwXeZ_AdedNvEhX"};